export default {
	methods: {
		//Deprecated
		/* 		checkFileValidForSlicer(file, errorCallback) {
					var isS = false;
					var reader = new FileReader();
					var fileType = file.type;
					console.log("type", fileType);
					reader.addEventListener("load", function () {
						var dataUrl = reader.result;
						var $videoEl = document.createElement('video');
						$videoEl.style.display = 'none';
						$("body").append($videoEl);
						$videoEl.src = dataUrl;

						var videoTagRef = $videoEl;
						videoTagRef.addEventListener('loadedmetadata', function (e) {
							console.log(videoTagRef.videoWidth, videoTagRef.videoHeight);
							if (videoTagRef.videoWidth !== videoTagRef.videoHeight) {
								errorCallback();
							}
						});

					}, false);

					if (file) {
						reader.readAsDataURL(file);
					}
				},


				arrayHas(array, element) {
					if (array.length === 0) {
						return false;
					}
					return array.indexOf(element) !== -1;
				},

				downloadFile(path, fileName) {
					var link = document.createElement('a');
					var href = "http://" + localStorage.env + ".roasup.com" + path;
					link.setAttribute('href', href);
					link.setAttribute('download', fileName);
					link.click();
					delete link;
				},

				copyToClipboard = str => {
					const el = document.createElement('textarea');
					el.value = str;
					el.setAttribute('readonly', '');
					el.style.position = 'absolute';
					el.style.left = '-9999px';
					document.body.appendChild(el);
					el.select();
					document.execCommand('copy');
					document.body.removeChild(el);
				}, */

		convertSecondsToTimeboardStyle(seconds, isDropFloatPart) {
			const sec_num = parseInt(seconds, 10);
			const hours = Math.floor(sec_num / 3600);
			const minutes = Math.floor(sec_num / 60) % 60;
			const secs = sec_num % 60;
			const msecs = Math.floor(seconds * 100) % 100;

			const timeToString = !isDropFloatPart
				? (hours > 0 ? [hours, minutes, secs, msecs] : [minutes, secs, msecs])
				: (hours > 0 ? [hours, minutes, secs] : [minutes, secs]);

			return timeToString
				.map(v => v < 10 ? "0" + v : v)
				.join(":");
		},
		calcStrSize(r) {
			r = Math.round(r * 100) / 100;
			//common
			if (r == 0.56) return "V";
			if (r == 0.67) return "P";
			if (r == 0.8) return "F";
			if (r == 1) return "S";
			if (r == 1.78) return "H";

			//uncommon
			if (0.34 <= r && r <= 0.55) return "LV";
			if (0.57 <= r && r <= 0.61) return "RV";

			if (0.62 <= r && r <= 0.66) return "LP";
			if (0.68 <= r && r <= 0.73) return "RP";

			if (0.74 <= r && r <= 0.79) return "LF";
			if (0.81 <= r && r <= 0.9) return "RF";

			if (0.91 <= r && r <= 0.99) return "LS";
			if (1.01 <= r && r <= 1.39) return "RS";

			if (1.4 <= r && r <= 1.77) return "LH";
			if (1.79 <= r && r <= 3.5) return "RH";
		}
	},
}

export function parseStoreStateToWorkspaceSnapshot(state) {
	return {
		defaultVariationNamingTemplate: state
			.defaultVariationNamingTemplate,
		userWorkParameters: state.userWorkParameters,
		variationNamingTemplate: state.variationNamingTemplate,
		items: state.items,
		renderItems: state.renderItems,
		muted: state.muted,
		showDownloadPanel: state.showDownloadPanel,
		recentImages: state.recentImages,
		recentMusics: state.recentMusics,
	};
}

export function throttle(func, ms) {
  let isThrottled = false,
    savedArgs,
    savedThis

  function wrapper() {
    if (isThrottled) {
      savedArgs = arguments
      savedThis = this
      return
    }

    func.apply(this, arguments)

    isThrottled = true

    setTimeout(function() {
      isThrottled = false
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs)
        savedArgs = savedThis = null
      }
    }, ms)
  }

  return wrapper
}